/**
 * Simple Mixed Cart Warning System
 * Just shows a basic informative message about mixed physical and digital products
 * No removal options - just notification
 */

class SimpleMixedCartWarning {
  constructor() {
    this.warningShown = false;
    this.init();
  }

  init() {
    // Listen for cart changes
    document.addEventListener('cart:item-added', () => this.checkCartForMixedProducts());
    document.addEventListener('line-item:change:end', () => this.checkCartForMixedProducts());
    
    // Check on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.checkCartForMixedProducts());
    } else {
      this.checkCartForMixedProducts();
    }
  }

  async checkCartForMixedProducts() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      if (!cart.items || cart.items.length === 0) {
        this.hideWarning();
        return;
      }

      const physicalProducts = cart.items.filter(item => item.requires_shipping);
      const nonPhysicalProducts = cart.items.filter(item => !item.requires_shipping);

      if (physicalProducts.length > 0 && nonPhysicalProducts.length > 0) {
        this.showSimpleWarning(physicalProducts, nonPhysicalProducts);
      } else {
        this.hideWarning();
      }
    } catch (error) {
      console.error('Error checking cart for mixed products:', error);
    }
  }

  showSimpleWarning(physicalProducts, nonPhysicalProducts) {
    if (this.warningShown) return;
    
    this.warningShown = true;

    const warningElement = this.createSimpleWarningElement(physicalProducts, nonPhysicalProducts);
    
    this.insertWarningIntoCart(warningElement.cloneNode(true));
    this.insertWarningIntoCartDrawer(warningElement.cloneNode(true));
  }

  createSimpleWarningElement(physicalProducts, nonPhysicalProducts) {
    const warning = document.createElement('div');
    warning.className = 'simple-mixed-cart-warning';
    warning.id = 'simple-mixed-cart-warning';
    
    warning.innerHTML = `
      <div style="
        background: #fff3cd;
        border-left: 4px solid #ffc107;
        padding: 12px 16px;
        margin: 15px 0;
        border-radius: 4px;
        font-size: 14px;
        line-height: 1.4;
      ">
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
          <strong style="color: #856404;">Mixed Cart Notice</strong>
          <button onclick="simpleMixedCartWarning.hideWarning()" style="
            margin-left: auto;
            background: none;
            border: none;
            font-size: 18px;
            color: #856404;
            cursor: pointer;
            padding: 0;
            line-height: 1;
          ">×</button>
        </div>
        <p style="margin: 0; color: #856404;">
          Your cart contains both physical products (${physicalProducts.length}) and digital/service products (${nonPhysicalProducts.length}). 
          Shipping charges will apply to the entire order.
        </p>
      </div>
    `;
    
    return warning;
  }

  insertWarningIntoCart(warningElement) {
    const cartForm = document.querySelector('.thb-cart-form');
    if (cartForm) {
      const existingWarning = cartForm.querySelector('#simple-mixed-cart-warning');
      if (existingWarning) {
        existingWarning.remove();
      }
      cartForm.insertBefore(warningElement, cartForm.firstChild);
    }
  }

  insertWarningIntoCartDrawer(warningElement) {
    const cartDrawer = document.querySelector('.cart-drawer .side-panel-content');
    if (cartDrawer) {
      const existingWarning = cartDrawer.querySelector('#simple-mixed-cart-warning');
      if (existingWarning) {
        existingWarning.remove();
      }
      
      const firstChild = cartDrawer.querySelector('.product-cart-item--container');
      if (firstChild) {
        cartDrawer.insertBefore(warningElement, firstChild);
      } else {
        cartDrawer.insertBefore(warningElement, cartDrawer.firstChild);
      }
    }
  }

  hideWarning() {
    this.warningShown = false;
    
    // Remove from main cart
    const cartWarning = document.querySelector('.thb-cart-form #simple-mixed-cart-warning');
    if (cartWarning) {
      cartWarning.remove();
    }
    
    // Remove from cart drawer
    const drawerWarning = document.querySelector('.cart-drawer #simple-mixed-cart-warning');
    if (drawerWarning) {
      drawerWarning.remove();
    }
  }
}

// Initialize the simple mixed cart warning system
let simpleMixedCartWarning;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    simpleMixedCartWarning = new SimpleMixedCartWarning();
  });
} else {
  simpleMixedCartWarning = new SimpleMixedCartWarning();
}

// Make it globally available
window.simpleMixedCartWarning = simpleMixedCartWarning;